import React from "react";
import { Field } from "redux-form";

import { CustomInput } from "components";
import { FormColumn, FormRow } from "components/layout";
import { trimNormalizer, onlyMaxDigits20 } from "validators";
import { onlyDigits, applyValidatorsIf } from "validators/userValidators";
import {
	maxLength20,
	onlyAlphanumericAndSpecialCharacters,
} from "validators/validation";

type TsysFieldsProps = {
	loading: boolean;
	name: string;
};

export const TsysFields = ({ loading, name }: TsysFieldsProps) => {
	const assosiationField = applyValidatorsIf(value => value?.length > 0)([
		maxLength20,
		onlyDigits,
	]);

	return (
		<>
			<FormRow>
				<FormColumn>
					<Field
						label="TSYS Esquire Association"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.esquire_association`}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
						validate={assosiationField}
						normalize={onlyMaxDigits20}
					/>
				</FormColumn>
				<FormColumn>
					<Field
						label="TSYS Evolve Association"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.evolve_association`}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
						validate={assosiationField}
						normalize={onlyMaxDigits20}
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<Field
						label="TSYS Merrick Association"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.merrick_association`}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
						validate={assosiationField}
						normalize={onlyMaxDigits20}
					/>
				</FormColumn>
				<FormColumn>
					<Field
						label="Rep Code"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.rep_code_one`}
						validate={maxLength20}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						normalize={onlyAlphanumericAndSpecialCharacters}
						hideRequiredMark
					/>
				</FormColumn>
			</FormRow>

			<Field
				component={CustomInput}
				type="hidden"
				name={`${name}.id`}
				disabled
				wrapperClassName="d-none"
			/>
		</>
	);
};
